import { useLazyQuery } from '@apollo/client'
import {
  Button,
  Hidden,
  Typography,
  Collapse,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import { Pagination } from '@material-ui/lab'
import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import PageHeader from '../../components/PageHeader'
import { GET_PROFORMAS_QUERY } from '../../graphql/walletProforma'
import { getTranslate } from '../../localization'
import { ProformaBrief, ProformaFilter } from '../../types/walletProforma'
import { FilterBoxDesktop } from './FilterBox'
import { ProformasTable } from './ProformaTable'
import useStyles from './styles/index.styles'

type WalletInvoiceListProps = {}

export default function WalletInvoiceList({}: WalletInvoiceListProps) {
  const classes = useStyles()
  const theme = useTheme()
  const params = useParams<{ walletId: string }>()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const [filters, setfilters] = useState<ProformaFilter>({
    walletID: params.walletId,
    includeExpired: false,
    status: undefined,
    timeRange: undefined
  })
  const [filterButtonSelected, setFilterButtonSelected] =
    useState<boolean>(false)

  const [perPage] = useState(5)
  const [page, setPage] = useState(1)
  const [count, setcount] = useState<number>(0)

  const [
    getProformas,
    { data: proformas, loading: loadingForProformas, refetch }
  ] = useLazyQuery<{ proformas: ProformaBrief[] }>(GET_PROFORMAS_QUERY, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      setcount(res.proformas.length)
    }
  })

  useEffect(() => {
    getProformas({
      variables: {
        filter: filters
      }
    })
  }, [filters])
  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])
  return (
    <div>
      <PageHeader title={getTranslate('Invoice List')} />
      <div className={classes.headerAndButtons}>
        <div className={classes.header}>
          <Typography variant="h3" gutterBottom>
            {getTranslate('Invoice List')}
          </Typography>
        </div>
        <div className={classes.buttons}>
          <Button
            size={isSmallScreen ? 'large' : 'small'}
            startIcon={<FilterListIcon />}
            variant="outlined"
            color="primary"
            onClick={() => setFilterButtonSelected(!filterButtonSelected)}>
            {isSmallScreen ? '' : getTranslate('Filter')}
          </Button>
        </div>
      </div>

      <Hidden smDown>
        <Collapse in={filterButtonSelected}>
          <FilterBoxDesktop
            filters={filters}
            setfilters={setfilters}
            setPage={setPage}
            getProformas={getProformas}
            loadingForProformas={loadingForProformas}
          />
        </Collapse>
      </Hidden>

      <ProformasTable
        data={
          proformas?.proformas.slice((page - 1) * perPage, page * perPage) || []
        }
        loading={loadingForProformas}
        reloadData={refetch}
      />

      {/* <Hidden smDown>
        <WalletListTableDesktop
          data={
            wallets?.wallets.slice((page - 1) * perPage, page * perPage) || []
          }
          {...{
            filters,
            setfilters,
            refetch,
            setPage,
            sort,
            setSort,
            loadingForWallets
          }}
        />
      </Hidden> */}
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          page={page}
          onChange={(_, value) => {
            setPage(value)
          }}
        />
      </div>
    </div>
  )
}
